import GlobalFields from 'defs/ga/fields/global';

export default {
	[GlobalFields.Event]: GlobalFields.Event,
	[GlobalFields.VirtualPageTitle]: GlobalFields.VirtualPageTitle,
	[GlobalFields.VirtualPageURL]: GlobalFields.VirtualPageURL,
	SiteType: 'siteType',
	PageType: 'pageType',
	ContentType: 'contentType',
	PageName: 'pnam',
	PageId: 'paid',
	PageGroupCategory: 'pgc',
	Language: 'lang',
	EnvironementId: 'eid',
	HTTPResponseCode: 'hrco',
	OriginalLocation: 'originalLocation',
	VisitorLoginState: 'vlst',
	Sex: 'geschlecht',
	Client: 'mandant',
};
